// extracted by mini-css-extract-plugin
export default {"Tab":"TabButton_Tab__f6OO7","TabActive":"TabButton_TabActive__RH3K2"};